import {
  CellBottomGroupPart,
  CellBottomPart,
  CellLeftStatusPart,
} from '@components/ui/Table/utils';
import { formatDate } from '@utils/index';

export const createCellValue = (
  property: string,
  data: any,
  index: number,
  isMobile: boolean
) => {
  const value = data[index][property];

  switch (property) {
    case 'status':
      return (
        <>
          <CellLeftStatusPart status={value} />
          <span>{value}</span>
        </>
      );
    case 'groups':
      return (
        <>
          <span>{value[0]?.name ?? 'Unassigned'}</span>
          {Array.isArray(value) && value.length - 1 > 0 && (
            <CellBottomGroupPart count={value.length - 1} />
          )}
        </>
      );
    case 'fullName':
      return (
        <>
          <span>{value}</span>
          {!isMobile && <CellBottomPart data={data[index]['emailAddress']} />}
        </>
      );
    case 'location':
      return (
        <>
          <span>{value ? value.name : 'Unassigned'}</span>
        </>
      );
    case 'userSince':
      return (
        <>
          <span>{formatDate(value)}</span>
        </>
      );
  }
};
